"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const tools_1 = require("../../utils/tools");
class BlockStream {
    constructor(baseUrl, headers) {
        this.api = (0, tools_1.getAxiosInstance)({
            baseUrl,
            headers,
        });
    }
    getOutspend(txId, index) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.api.get(`/tx/${txId}/outspend/${index}`);
            return response.data;
        });
    }
    getOutspends(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.api.get(`/tx/${txId}/outspends`);
            return response.data;
        });
    }
    getLatestBlockNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/blocks/tip/height`);
            return result.data;
        });
    }
    getBlockHash(blockNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/block-height/${blockNumber}`);
            return result.data;
        });
    }
    getBlockHeaderHex(blockNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const hash = yield this.getBlockHash(blockNumber);
            const result = yield this.api.get(`/block/${hash}/header`);
            return result.data;
        });
    }
    getConfirmedTransactions(userAddress, lastReceivedTxId = "") {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/address/${userAddress}/txs/chain/${lastReceivedTxId}`);
            return result.data;
        });
    }
    getMempoolTransactions(userAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/address/${userAddress}/txs/mempool`);
            return result.data;
        });
    }
    getTransaction(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/tx/${txId}`);
            let tx = result.data;
            return {
                txId: tx.txid,
                version: tx.version,
                locktime: tx.locktime,
                blockTime: tx.status.block_time,
                blockNumber: tx.status.block_height || null,
                blockHash: tx.status.block_hash || null,
                vout: tx.vout.map((vo) => ({
                    address: vo.scriptpubkey_address || null,
                    script: vo.scriptpubkey,
                    value: vo.value,
                })),
                vin: tx.vin.map((vi) => ({
                    txId: vi.txid,
                    index: vi.vout,
                    address: vi.prevout.scriptpubkey_address || null,
                    script: vi.prevout.scriptpubkey,
                    value: vi.prevout.value,
                })),
            };
        });
    }
    getRawTransaction(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/tx/${txId}/hex`);
            return result.data;
        });
    }
    getTransactionHistory(userAddress, blockNumber = 0, lastSeenTxId = undefined) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let maximumTxsLength = 15;
            let fetchTxs = true;
            let allResults = [];
            let lastReceivedTxId = "";
            while (fetchTxs) {
                let result = yield this.getConfirmedTransactions(userAddress, lastReceivedTxId);
                let lastSeenTxIdIndex = result.findIndex((tx) => tx.txid === lastSeenTxId);
                result = result.filter((_value) => +_value.status.block_height > blockNumber);
                result =
                    lastSeenTxIdIndex < 0
                        ? result
                        : result.filter((_value, index) => index < lastSeenTxIdIndex);
                allResults.push(...result);
                lastReceivedTxId = (_a = result[result.length - 1]) === null || _a === void 0 ? void 0 : _a.txid;
                fetchTxs = result.length === maximumTxsLength && lastSeenTxIdIndex < 0 && result.length !== 0;
            }
            return allResults.map((tx) => ({
                address: userAddress,
                txId: tx.txid,
                version: tx.version,
                locktime: tx.locktime,
                blockNumber: tx.status.block_height || null,
                blockHash: tx.status.block_hash || null,
                blockTime: tx.status.block_time || null,
                vout: tx.vout.map((vo) => ({
                    address: vo.scriptpubkey_address || null,
                    script: vo.scriptpubkey,
                    value: vo.value,
                })),
                vin: tx.vin.map((vi) => ({
                    txId: vi.txid,
                    index: vi.vout,
                    address: vi.prevout.scriptpubkey_address || null,
                    script: vi.prevout.scriptpubkey,
                    value: vi.prevout.value,
                })),
            }));
        });
    }
    getMempoolTransactionHistory(userAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this.getMempoolTransactions(userAddress);
            return result.map((tx) => ({
                address: userAddress,
                txId: tx.txid,
                version: tx.version,
                locktime: tx.locktime,
                vout: tx.vout.map((vo) => ({
                    address: vo.scriptpubkey_address || null,
                    script: vo.scriptpubkey,
                    value: vo.value,
                })),
                vin: tx.vin.map((vi) => ({
                    txId: vi.txid,
                    index: vi.vout,
                    address: vi.prevout.scriptpubkey_address || null,
                    script: vi.prevout.scriptpubkey,
                    value: vi.prevout.value,
                })),
            }));
        });
    }
    getMempoolTransactionHistoryForMultipleAddresses(addresses) {
        return __awaiter(this, void 0, void 0, function* () {
            const allPromises = [];
            for (let address of addresses) {
                let promise = yield this.getMempoolTransactionHistory(address);
                allPromises.push(promise);
            }
            let result = yield Promise.all(allPromises);
            return result;
        });
    }
    getTransactionHistoryForMultipleAddresses(userAddresses, blockNumber = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const allPromises = [];
            for (let address of userAddresses) {
                let promise = yield this.getTransactionHistory(address, blockNumber);
                allPromises.push(promise);
                yield (0, tools_1.sleep)(200);
            }
            let result = yield Promise.all(allPromises);
            return result;
        });
    }
    getUtxos(userAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/address/${userAddress}/utxo`);
            return result.data.map((tx) => {
                var _a;
                return ({
                    address: userAddress,
                    txId: tx.txid,
                    index: tx.vout,
                    value: tx.value,
                    blockNumber: ((_a = tx.status) === null || _a === void 0 ? void 0 : _a.block_height) || undefined,
                });
            });
        });
    }
    getBalance(address) {
        return __awaiter(this, void 0, void 0, function* () {
            let utxos = yield this.getUtxos(address);
            return utxos.reduce((a, tx) => a + Number(tx.value), 0);
        });
    }
    getBlockTransactionIds(blockHash) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this.api.get(`/block/${blockHash}/txids`);
            return result.data;
        });
    }
    getFeeRate(speed = "normal") {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this.api.get(`/fee-estimates`);
            let fees = {
                slow: +result.data[10],
                normal: +result.data[6],
                fast: +result.data[3],
            };
            return fees[speed] || fees.normal;
        });
    }
    getRecommendedFeeRate(speed = "normal") {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this.api.get(`/v1/fees/recommended`);
            let fees = {
                slow: +result.data.economyFee,
                normal: +result.data.halfHourFee,
                fast: +result.data.fastestFee,
            };
            return fees[speed] || fees.normal;
        });
    }
    sendRawTransaction(rawTransaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.post(`/tx`, rawTransaction);
            return result.data;
        });
    }
    getMerkleProof(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = (yield this.api.get(`/tx/${txId}/merkle-proof`)).data;
            let intermediateNodes = result.merkle.reduce((a, merkle) => a + Buffer.from(merkle, "hex").reverse().toString("hex"), "0x");
            let transactionIndex = result.pos;
            return {
                intermediateNodes,
                transactionIndex,
            };
        });
    }
    getLatestBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.api.get(`/blocks`);
            const blocks = result.data;
            return blocks[0];
        });
    }
    getBlock(blockNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockHash = yield this.getBlockHash(blockNumber);
            const result = yield this.api.get(`/block/${blockHash}`);
            return result.data;
        });
    }
}
exports.default = BlockStream;
//# sourceMappingURL=mempool-space-default.js.map